import React from "react";

interface StepperProps {
  className?: string;
  totalSteps: number;
  currentStep: number;
}

const Stepper: React.FC<StepperProps> = ({
  className,
  totalSteps,
  currentStep,
}) => {
  const progress = Math.round((currentStep / totalSteps) * 100);
  return (
    <div className={className}>
      <div className="flex items-center justify-between">
        <div className="text-sm text-gray-600">
          Step {currentStep} of {totalSteps}
        </div>
        <div className="text-sm text-gray-600">{progress.toFixed(0)}%</div>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full mt-2">
        <div
          className="h-full bg-[var(--app-primary)] rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default Stepper;
